'use client';

import { IcInfo, Sheet, SheetTrigger } from '@musinsa/mds';
import dynamic from 'next/dynamic';
import type { FC } from 'react';
import { useState } from 'react';

const DynamicRankingDescriptionSheet = dynamic(
  () =>
    import('./RankingDescriptionSheet').then((mod) => ({
      default: mod.RankingDescriptionSheet,
    })),
  {
    ssr: false,
  },
);

export const RankingDescription: FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
  };

  const handleSheetOpen = () => {
    setIsOpen(true);
  };
  const handleSheetClose = () => {
    setIsOpen(false);
  };

  return (
    <Sheet direction="bottom" open={isOpen} onOpenChange={handleOpenChange}>
      <SheetTrigger asChild onClick={handleSheetOpen}>
        <button type="button">
          {/* NOTE: 아이콘의 색상이 black으로 고정. important처리 하지 않으면 우선순위가 밀림 */}
          <IcInfo width={16} height={16} className="[&_path]:stroke-base-gray-9!" />
        </button>
      </SheetTrigger>
      <DynamicRankingDescriptionSheet onClose={handleSheetClose} />
    </Sheet>
  );
};
